<div class="row">
  <div class="col-12" id="settingsContainer">
    <div class="settings-window">
      <div class="upper-row">
        <span class="title">Settings</span>
      </div>
      <div class="settings-main">
        <div *ngIf="loading" class="loading">
          <app-loader label="Loading settings"></app-loader>
        </div>
        <div *ngIf="!loading">
          <div>
            <h1>Images</h1>
            <h2>Select image model</h2>
            <app-image-model-chooser [imageModel]="'image'" [selectedImageModelName]="userImageSettings.image.model"
                                     (changeImageModelName)="onSettingsChange($event, 'image')"></app-image-model-chooser>
          </div>
          <div>
            <h1>Videos</h1>
            <h2>Select video model</h2>
            <app-image-model-chooser [imageModel]="'video'" [selectedImageModelName]="userImageSettings.video.model"
                                     (changeImageModelName)="onSettingsChange($event, 'video')"></app-image-model-chooser>
            <h2>Sound in the movie</h2>
            <app-image-model-item [imageModel]="muteSettings" (click)="selectedModel(muteSettings)"></app-image-model-item>
          </div>

          <div class="bottom-button-row">
            <button class="blue-bg button-blueGDPR" (click)="save()" [disabled]="disabledButton">Save</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
